export default __webpack_public_path__ + "static/media/Goal Breakdown worksheet.811f887f.pdf";